import ConfigView from './configView';
import ImageViewerSelectWidget from './imageViewerSelectWidget';
import * as imageViewerWidget from './imageViewerWidget';

export {
    ConfigView,
    ImageViewerSelectWidget,
    imageViewerWidget
};



// WEBPACK FOOTER //
// ./plugins/large_image/web_client/views/index.js